module.exports = __webpack_public_path__ + "img/35daad5.png";